import { Component, Input } from "@angular/core";

@Component({
  selector: "app-page-header",
  templateUrl: "./page-header.component.html",
  styleUrls: ["./page-header.component.scss"],
})

/**
 * Page Header Component
 * Componente reutilizável para cabeçalho de páginas sem botão e com subtexto
 */
export class PageHeaderComponent {
  @Input() title: string = "";
  
  @Input() icon: string | undefined;
  
  @Input() subtitle: string = "";
}
